import {makeStyles} from '@material-ui/core/styles'
import {useEffect, useState} from 'react'
import DataEntryCardApproval from '../../../components/3modules/DashboardDataEntry/DataEntryCardApproval'
import FullView from '../../../components/5templates/FullView'
import {getItemFromSessionStorage} from '../../../services/util/sessionStorageManager'
import uuid from 'react-uuid'
import {formatDate} from '../../../services/util/formatter'
import DateSelector from '../../../components/1elements/Fields/DateSelector'
import {ITooltip} from '../../../components/1elements'
import {hasOnlyNumbers} from '../../../services/util/miscellaneousService'
import VerticalSingleSelectEditCell from '../../../components/3modules/DashboardDataEntry/VerticalSingleSelectEditCell'

const ApproveDashboard = () => {
    const classes = useStyles()
    const [editable, setEditable] = useState(false)

    const [metricsData, setMetricsData] = useState([])
    const [commentsData, setCommentsData] = useState([])

    const [addModeMetrics, setAddModeMetrics] = useState(false)
    const [editModeMetrics, setEditModeMetrics] = useState(false)
    const [deleteModeMetrics,] = useState(false)

    const [addModeComment, setAddModeComment] = useState(false)
    const [editModeComment, setEditModeComment] = useState(false)
    const [deleteModeComment,] = useState(false)
    const parseDate = (params) => {
        return formatDate(params.value, 'YYYY-MM-DD')
    }

    const [metricsTableColumns, setMetricsTableColumns] = useState([
        {
            field: 'date',
            headerName: 'Date',
            width: 150,
            isShown: true,
            type: 'date',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: parseDate,
            renderEditCell: (params) => {
                const { id, api, field } = params
                const handleChange = async (value) => {
                    api.setEditCellValue({ id, field, value: value })
                };
                return(
                    <DateSelector value={params.value} onChange={handleChange} disableFuture />
                )}
        },
        {
            field: 'satisfactionScore',
            headerName: 'Satisfaction',
            flex: 1,
            minWidth: 130,
            isShown: true,
            type: 'string',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: (params) => {
                if(params.value&&hasOnlyNumbers(params.value)){
                    return Math.round(params.value)
                }
                return null
            },
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value < 0 || params.props.value > 100
                return { ...params.props, error: hasError }
            },
        },
        {
            field: 'inspectionScore',
            headerName: 'Inspection',
            flex: 1,
            minWidth: 130,
            isShown: true,
            type: 'string',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: (params) => {
                if(params.value&&hasOnlyNumbers(params.value)){
                    return Math.round(params.value)
                }
                return null
            },
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value < 0 || params.props.value > 100
                return { ...params.props, error: hasError }
            },
        },
        {
            field: 'complianceScore',
            headerName: 'Compliance',
            flex: 1,
            minWidth: 130,
            isShown: true,
            type: 'string',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: (params) => {
                if(params.value&&hasOnlyNumbers(params.value)){
                    return Math.round(params.value)
                }
                return null
            },
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value < 0 || params.props.value > 100
                return { ...params.props, error: hasError }
            },
        },
        {
            field: 'incidentCount',
            headerName: 'Incident(s)',
            flex: 1,
            minWidth: 130,
            isShown: true,
            type: 'string',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: (params) => {
                if(params.value&&hasOnlyNumbers(params.value)){
                    return Math.round(params.value)
                }
                return null
            },
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value < 0
                return { ...params.props, error: hasError }
            },
        },
        {
            field: 'reportCount',
            headerName: 'Report(s)',
            flex: 1,
            minWidth: 130,
            isShown: true,
            type: 'string',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueFormatter: (params) => {
                if(params.value&&hasOnlyNumbers(params.value)){
                    return Math.round(params.value)
                }
                return null
            },
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value < 0
                return { ...params.props, error: hasError }
            },
        },
    ])

    const [commentsTableColumns, setCommentsTableColumns] = useState([
        {
            field: 'date',
            headerName: 'Date',
            width: 150,
            isShown: true,
            type: 'date',
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            valueParser: parseDate,
            renderEditCell: (params) => {
                const { id, api, field } = params
                const handleChange = async (value) => {
                    api.setEditCellValue({ id, field, value: value })
                }
                return(
                    <DateSelector value={params.value} onChange={handleChange} disableFuture />
                )}
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            isShown: true,
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            renderCell: (params) =>(
                params.value && params.value.length > 15
                    ? (
                        <ITooltip placement={'top'} content={params.value}>
                            <div className={classes.nameCell}>
                                {params.value}
                            </div>
                        </ITooltip>
                    )
                    : (params.value)
            ),
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value && params.props.value.length > 50
                return { ...params.props, error: hasError };
            },
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 150,
            isShown: true,
            type: 'singleSelect',
            valueOptions: ['client', 'staff'],
            renderEditCell: (params) => (
                <VerticalSingleSelectEditCell {...params} />
            ),
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
        },
        {
            field: 'comment',
            headerName: 'Comment',
            flex: 1,
            minWidth: 300,
            isShown: true,
            renderHeader: (params) => (
                <ITooltip placement={'top'} content={'Sort'}>
                    {params.colDef.headerName}
                </ITooltip>
            ),
            renderCell: (params) =>(
                params.value && params.value.length > 50
                    ? (
                        <ITooltip placement={'top'} content={params.value}>
                            <div className={classes.commentCell}>
                                {params.value}
                            </div>
                        </ITooltip>
                    )
                    : (params.value)
            ),
            preProcessEditCellProps: (params) => {
                const hasError = params.props.value&&params.props.value.length > 500
                return { ...params.props, error: hasError };
            },

        },
    ])

    useEffect( ()=>{
        const addComment = getItemFromSessionStorage('addComment')
        const editComment = getItemFromSessionStorage('editComment')
        const deleteComment = getItemFromSessionStorage('deleteComment')
        const addDashboardMetrics = getItemFromSessionStorage('addDashboardMetrics')
        const editDashboardMetrics = getItemFromSessionStorage('editDashboardMetrics')
        const deleteDashboardMetrics = getItemFromSessionStorage('deleteDashboardMetrics')
        const rejected = getItemFromSessionStorage('rejected')

        if(addComment){
            const {comment_data} = addComment
            const {commenterName, comment, date, commenterType} = comment_data
            setCommentsData([{
                id: uuid(),
                date: date,
                name: commenterName,
                type: commenterType,
                comment: comment
            }])

            if(rejected){
                setAddModeComment(true)
                setEditable(true)
                const commentsTableColumnsCopy = [...commentsTableColumns]
                for(let i = 0; i < commentsTableColumnsCopy.length; i++){
                    commentsTableColumnsCopy[i].editable = true
                }
                setCommentsTableColumns(commentsTableColumnsCopy)
            }
        }
        if(addDashboardMetrics){
            const {dashboard_data} = addDashboardMetrics
            const {clientScore, inspectionScore, complianceScore, reportCount, incidentCount, date} = dashboard_data
            setMetricsData([{
                id: uuid(),
                date: date,
                originalDate: date,
                satisfactionScore: clientScore,
                inspectionScore: inspectionScore,
                complianceScore: complianceScore,
                incidentCount: incidentCount,
                reportCount: reportCount
            }])
            if(rejected){
                setAddModeMetrics(true)
                setEditable(true)
                const metricsTableColumnsCopy = [...metricsTableColumns]
                for(let i = 0; i < metricsTableColumnsCopy.length; i++){
                    metricsTableColumnsCopy[i].editable = true
                }
                setMetricsTableColumns(metricsTableColumnsCopy)
            }
        }

        if(editComment){
            const {comment_data} = editComment
            const {commenterName, comment, date, commenterType} = comment_data
            setCommentsData([{
                id: uuid(),
                date: date,
                originalDate: date,
                name: commenterName,
                type: commenterType,
                comment: comment
            }])
            if(rejected){
                setEditModeComment(true)
                setEditable(true)
                const commentsTableColumnsCopy = [...commentsTableColumns]
                for(let i = 0; i < commentsTableColumnsCopy.length; i++){
                    commentsTableColumnsCopy[i].editable = true
                }
                setCommentsTableColumns(commentsTableColumnsCopy)
            }
        }
        if(editDashboardMetrics){
            const {dashboard_data, created_at} = editDashboardMetrics
            const {clientScore, inspectionScore, complianceScore, reportCount, incidentCount} = dashboard_data
            setMetricsData([{
                id: uuid(),
                date: formatDate(created_at, 'YYYY-MM-DD'),
                originalDate: formatDate(created_at, 'YYYY-MM-DD'),
                satisfactionScore: clientScore,
                inspectionScore: inspectionScore,
                complianceScore: complianceScore,
                incidentCount: incidentCount,
                reportCount: reportCount
            }])
            if(rejected){
                setEditModeMetrics(true)
                setEditable(true)
                const metricsTableColumnsCopy = [...metricsTableColumns]
                for(let i = 0; i < metricsTableColumnsCopy.length; i++){
                    metricsTableColumnsCopy[i].editable = true
                }
                setMetricsTableColumns(metricsTableColumnsCopy)
            }
        }

        if(deleteComment){
            const {comment_data} = deleteComment
            const {commenter_name, dashboard_comment, created_at, commenter_type} = comment_data
            setCommentsData([{
                id: uuid(),
                date: formatDate(created_at, 'YYYY-MM-DD'),
                name: commenter_name,
                type: commenter_type,
                comment: dashboard_comment
            }])
        }
        if(deleteDashboardMetrics){
            const {dashboard_data} = deleteDashboardMetrics
            const {client_score, inspection_score, compliance_score, report_count, incident_count, created_at} = dashboard_data
            setMetricsData([{
                id: uuid(),
                date: formatDate(created_at, 'YYYY-MM-DD'),
                satisfactionScore: client_score,
                inspectionScore: inspection_score,
                complianceScore: compliance_score,
                incidents: incident_count,
                reports: report_count
            }])
        }
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])


    return (
        <FullView disabled noWidgets>
            <div className={classes.root}>
                <div className={classes.innerDiv}>
                    <DataEntryCardApproval heading={'Dashboard Metrics'} columns={metricsTableColumns} editable={editable}
                                           setColumns={setMetricsTableColumns} data={metricsData}
                                           addMode={addModeMetrics} deleteMode={deleteModeMetrics} editMode={editModeMetrics} />
                    <DataEntryCardApproval heading={'Comments'} columns={commentsTableColumns} editable={editable}
                                           setColumns={setCommentsTableColumns} data={commentsData}
                                            addMode={addModeComment} deleteMode={deleteModeComment} editMode={editModeComment}/>
                </div>
            </div>
        </FullView>
    )
}

export default ApproveDashboard

const useStyles = makeStyles({
    root: {
        height: '80vh',
        width: 'calc(100% - 60px)'
    },
    innerDiv: {
        height: '100%',
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '20px'
    },
    commentCell: {
        width: '300px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    nameCell: {
        width: '140px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }
})
